import { combineReducers, configureStore } from "@reduxjs/toolkit";

import { newPolicyReducers } from "@covertree/new-business-redux";

import { client } from "@apolloClient/client";

import { endorsementReducers } from "./slices/endorsement";
import { restApi } from "./restApi";

export const rootReducer = combineReducers({
  newPolicy: newPolicyReducers,
  endorsement: endorsementReducers,
  [restApi.reducerPath]: restApi.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: {
        extraArgument: { client },
      },
    }).concat([restApi.middleware]),
});
export const resetCache = () => {
  // TODO: Add cache clear for RTK
};

export type RootState = ReturnType<typeof store.getState>;
export type RootStore = typeof store;
export type AppDispatch = typeof store.dispatch;

export type ReturnRootState = () => RootState;
export type ThunkAPI = { dispatch: AppDispatch; state: RootState };
